import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class AdobeTagService {
	loadAllstateScript(scriptUrl: string): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			// Check if the script element already exists
			if (document.querySelector(`script[src="${scriptUrl}"]`)) {
				resolve();

				return;
			}

			const scriptElement = document.createElement('script');
			scriptElement.setAttribute('src', scriptUrl);
			scriptElement.onload = () => {
				resolve();
			};
			scriptElement.onerror = () => {
				reject();
			};
			document.head.appendChild(scriptElement);
		});
	}
}
